import { useMemo } from "react";
import { getColorFromCssVariable } from "ui";
import { BarChartCard } from "../shared/BarChartCard";
import { CATEGORICAL_COLOR_VARIABLES } from "../shared/chartColors";
import { useDatadogQuery } from "../../DatadogAnalytics/useDatadogQuery";

type RevenueSeries = {
  label: string;
  data: number[];
}[];

type RevenueBreakdownData = {
  labels: string[];
  series: RevenueSeries;
};

type RevenueBreakdownChartProps = {
  title: string;
  description?: string;
  chartType: "REVENUE_BY_PROVIDER" | "REVENUE_BY_METHOD";
};

export function RevenueBreakdownChart({
  title,
  description,
  chartType,
}: RevenueBreakdownChartProps) {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<RevenueBreakdownData>({ chartType });

  const colors = useMemo(
    () =>
      CATEGORICAL_COLOR_VARIABLES.map((variable) =>
        getColorFromCssVariable(variable)
      ),
    []
  );

  const datasets = useMemo(
    () =>
      (data?.series ?? []).map((item, index) => {
        const color = colors[index % colors.length];

        return {
          label: item.label,
          data: item.data,
          backgroundColor: color,
          borderColor: color,
          stack: "stack0",
        };
      }),
    [data, colors]
  );

  return (
    <BarChartCard
      ref={ref}
      title={title}
      description={description}
      format="currency"
      labels={data?.labels ?? []}
      datasets={datasets}
      showSingleDatasetLegend
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
    />
  );
}
